<div class="w-full grid dashboard-grid gap-4 mt-1 mb-5 pb-4 items-start">
  <ng-container *ngFor="let component of (components$ | async)">
    <ng-container *ngComponentOutlet="component"> </ng-container>
  </ng-container>
</div>
